import { render, staticRenderFns } from "./MR.vue?vue&type=template&id=cf3372ee&scoped=true&"
import script from "./MR.vue?vue&type=script&lang=js&"
export * from "./MR.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf3372ee",
  null
  
)

export default component.exports